import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import './toast.css';

export default function ToastComponent({ isToastOpen, setIsToastOpen, message, containerClsNames, style }) {
  const [state] = useState({
    vertical: 'top',
    horizontal: 'center',
  });
  const { vertical, horizontal } = state;

  const action = (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={() => setIsToastOpen(false)}
    >
      <CloseIcon fontSize="small" sx={{ width: '24px', height: '24px' }} />
    </IconButton>
  );

  return (
    <Box sx={{ width: 500, fontSize: '20px' }}>
      <Snackbar
        className={containerClsNames}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={isToastOpen}
        onClose={() => setIsToastOpen(false)}
        message={message}
        key={vertical + horizontal}
        action={action}
        style={style}
        autoHideDuration={5000}
      />
    </Box>
  );
}